<template>
  <div class="payment__instrument">
    <div v-if="!processing && !fetchingPaymentTypes">
      <div class="label">{{ $t('Payments.PNM.PayPal.Headline') }}</div>
      <div class="desc">{{ $t('Payments.PNM.PayPalWithdrawal.Desc') }}</div>
      <!-- Error Msg -->
      <div v-if="errorMessage" class="pnmpd-failed">{{errorMessage}}</div>
      <!-- Info Msg -->
      <div v-if="infoMessage" class="pnmpd-info acc_infomsg_default"><v-icon color="blue" class="mr-1" size="16">info</v-icon> {{infoMessage}}</div>
      <!--Template to display if there is no paypal acc added -->
      <div class="pnmpd-cards" v-if="!paypalAccount">
        <!-- changed because of MEGA-293-->
        <p class="no__cards__info"><b>{{ $t('Payments.PNM.PayPalWithdrawal.Enable') }}</b></p>
        <div class="no__cards__info">{{ $t('Payments.PNM.PayPalWithdrawal.Info') }}</div>
      </div>
      <div v-else>
        <!--Template to display if Paypal account is added -->
        <!--Form -->
        <div class="pnmpd-cards pnmpd-cards__form payments_form" :class="{'pnmpd-cards__form--visible': paypalAccount}">
          <div class="hdr">{{ $t('Payments.PNM.PushDebit.EnterAmount') }}</div>
          <v-form ref="form" id="form" v-model="valid" lazy-validation @submit.prevent="submit">
            <v-text-field
              inputmode="decimal"
              v-model="formData.amount"
              :label="$t('Transaction.Amount')"
              :prefix="currencySymbol"
              required
              :disabled="processing"
              :rules="[formRules.amount.required, formRules.amount.number]"
              class="my-3 input-amount"
            >
            </v-text-field>
            <div class="pi-btns-wrapper">
              <v-btn large :disabled="processing || !valid || !customerCanWithdraw" color="success" @click="startTransaction(formData.amount)">{{ $t('Transaction.Withdrawal') }}</v-btn>
            </div>
          </v-form>
        </div>
      </div>
      <!-- Back to cashier -->
      <div class="go-back">
        <span class="go-back-content" @click="goToHomepage()"><v-icon>navigate_before</v-icon><span>{{back}}</span></span>
      </div>
    </div>
    <!-- Spinner -->
    <div v-else class="payments__spinner">
      <v-progress-circular indeterminate class="redirecting-circular-progress"></v-progress-circular>
      {{ defaultProcessingMessage }}
    </div>
    <PNMGatewayDialog v-if="redirectionUrl"
      :redirectionUrl="redirectionUrl"
      :type="'pnmPayPal'"
      ref="pnmGatewayDialog">
    </PNMGatewayDialog>
    <PNMEventDispatcher/>
  </div>
</template>
<script>
import store from '@/store'
import config from '@/config'
import PNMGatewayDialog from '@/components/payments/PayNearMeGateway/PNMGatewayDialog'
import PNMEventDispatcher from '@/components/payments/PayNearMeGateway/PNMEventDispatcher'

let viewModel = null

export default {
  components: {
    PNMGatewayDialog,
    PNMEventDispatcher
  },
  props: ['type'],
  data: () => ({
    formData: {
      amount: ''
    },
    formRules: {
      amount: {
        required: (value) => !!value || viewModel.$t('Transaction.Amount.IsRequired'),
        number: (value) => (value > 0) || viewModel.$t('Transaction.Amount.Number')
      }
    },
    valid: true,
    displayCards: false
  }),
  methods: {
    startTransaction (amt) {
      if (this.$refs.form.validate()) {
        try {
          store.commit('payments/analytics/setAmount', amt)
          store.dispatch('pnmGateway/pnmPushDebit/start', {
            amount: amt,
            instrument: this.paypalAccount,
            shouldOpenIFrame: false,
            isWithdrawal: true
          })
          this.disposeLocalState()
        } catch (ex) {
          console.log(ex)
        }
      }
    },
    goToHomepage () {
      this.$router.push({name: 'wallet-page'})
    },
    closePNMIFrame () {
      if (this.$refs && this.$refs.pnmGatewayDialog) {
        this.$refs.pnmGatewayDialog.closeDialog()
      }
    },
    addPayPalAccount () {
      try {
        store.dispatch('pnmGateway/pnmPayPal/start', 'addNewAccount')
        this.disposeLocalState()
      } catch (ex) {
        console.log(ex)
      }
    },
    cardCheck () {
      try {
        store.dispatch('pnmGateway/pnmPushDebit/start', {
          amount: 0,
          instrument: this.defaultInstument,
          shouldOpenIFrame: false,
          isWithdrawal: false
        })
        this.disposeLocalState()
      } catch (ex) {
        console.log(ex)
      }
    },
    disposeLocalState () {
      this.formData.amount = ''
      this.valid = true
    }
  },
  computed: {
    fetchingPaymentTypes: () => store.getters['payments/fetchingPaymentTypes'],
    processing () {
      return store.getters['pnmGateway/pnmPushDebit/getProcessing'] || store.getters['pnmGateway/pnmPayPal/getProcessing']
    },
    defaultProcessingMessage () {
      return this.$t('Transaction.PleaseWait')
    },
    errorMessage () {
      const msg = store.getters['pnmGateway/pnmPushDebit/errMsg']
      return msg
    },
    paypalAccount: () => {
      let instruments = store.getters['payments/activePaymentInstuments']
      return instruments && instruments
        .find(type => type.IDMMSIType === 'PNMPushDebit' && type.VerificationStatus === -1 && type.ExtraValue1 === 'PayPal')
    },
    defaultInstument () {
      let instruments = store.getters['payments/activePaymentInstuments']
      return instruments && instruments.filter(type => type.IDMMSIType === 'PNMPushDebit')[0]
    },
    redirectionUrl: () => store.getters['pnmGateway/pnmPayPal/redirectionURL'],
    infoMessage: () => store.getters['pnmGateway/pnmPushDebit/infoMsg'],
    currencySymbol () {
      return config.app.CURRENCY
    },
    back () {
      return this.$t('Transaction.GoBack')
    },
    transactionType: () => store.getters['payments/transactionType'],
    withdrawType () {
      return this.transactionType && this.transactionType === 'withdrawal'
    },
    customerContext: () => store.getters['getCustomerContext'],
    customerCanWithdraw () {
      return this.customerContext && this.customerContext.ActionWithdraw
    },
    isPaypalWithdrawal () {
      return this.$route.name.includes('pnm-paypal-withdrawal')
    }
  },
  created () {
    viewModel = this
  },
  mounted () {
    store.dispatch('pnmGateway/pnmPushDebit/disposeState')
    store.dispatch('getCustomerContext')
    if (this.defaultInstument) {
      this.cardCheck()
    }
  },
  destroyed () {
    store.dispatch('pnmGateway/pnmPushDebit/disposeState')
    this.disposeLocalState()
  },
  watch: {
    // on page refresh
    defaultInstument (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.cardCheck()
      }
    }
  }
}

window.addEventListener('message', params => {
  if (params && params.data && params.data.data === 'closePNMPushDebitIFrame') {
    store.dispatch('getCustomerContext')
    // viewModel reference exist => PNMPushDebit component is rendered => transaction is push debit
    if (viewModel) {
      if (viewModel.isPaypalWithdrawal) {
        viewModel.closePNMIFrame()
        viewModel.disposeLocalState()
        viewModel.cardCheck()
      }
    }
  }
})
</script>
<style lang="stylus" scoped>
.payment__instrument
  cursor default
  .pnmpd-info,
  .pnmpd-success,
  .pnmpd-failed
    border-radius 5px
    padding 10px
    margin 0 0 5px 0
  .pnmpd-info
    background #e5e5e5
    font-size 12px
  .pnmpd-success
    background rgba(76, 175, 80, .2)
    font-size initial
  .pnmpd-failed
    background rgba(244, 67, 54, .2)
    font-size initial
    &.pnmpd-failed--hidden
      display none
  .pnmpd-cards
    border 1px solid #e5e5e5
    margin 10px 0
    padding 10px
    border-radius 5px
    &.pnmpd-cards__form
      opacity 0
      transition opacity 1s
      display none
      &.pnmpd-cards__form--visible
        opacity 1
        display block
    .no__cards__info
      margin 0 5px 15px
    .pnmpd__btn_cont
      display flex
      justify-content center
    .hdr
      display flex
      justify-content space-between
      align-items center
      cursor pointer
    .pnmpd-cards__body
      max-height 0
      overflow hidden
      transition max-height .8s ease-out
      &.pnmpd-cards__body--visible
        max-height 1000px
        transition max-height .8s ease-in
</style>



// WEBPACK FOOTER //
// src/components/payments/PayNearMeGateway/PNMPayPalWithdrawal.vue